import { Component, Input } from '@angular/core';

@Component({
  selector: 'sba-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss']
})
export class CheckboxComponent {
  @Input()
  selected: boolean;
}
